import type {
  FundingGroupOptionDto,
  LoanProductPartnerOptionDto,
} from "~/api/dto/loan-product-partner.dto"

/**
 * The seller-facing name of a Finance Partner. `labelKey` comes from the loan
 * product catalog rather than the translation bundle, so a key with no entry
 * falls back to the raw finance type instead of rendering the key itself.
 */
export const financePartnerLabel = (
  partner: LoanProductPartnerOptionDto,
  translate: (key: string) => string,
): string => {
  const translated = translate(partner.labelKey)
  return translated === partner.labelKey ? partner.financeType : translated
}

/** The seller-facing name of a funding group, falling back to its stored value. */
export const fundingGroupLabel = (
  group: FundingGroupOptionDto,
  translate: (key: string) => string,
): string => {
  const translated = translate(group.labelKey)
  return translated === group.labelKey ? group.value : translated
}
